export default __webpack_public_path__ + "./images/na.df7ecf4b.png";